/* eslint-disable no-sparse-arrays */
export const baseURL = import.meta.env.VITE_BASE_URL;
export const S3Bucket = import.meta.env.VITE_S3_BUCKET;
export const CDN = import.meta.env.VITE_CDN;
export const exceptThisSymbols = ['e', 'E', '+', '-', '.'];